var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _vm.title
        ? _c("div", { staticClass: "mb-40 d-flex flex-wrap w-100" }, [
            _c("h3", {
              staticClass: "title",
              domProps: { innerHTML: _vm._s(_vm.title) }
            }),
            _vm._v(" "),
            _vm.generatedCtaLink
              ? _c(
                  "a",
                  {
                    staticClass: "ml-auto my-auto link-arrow",
                    attrs: { href: _vm.generatedCtaLink }
                  },
                  [
                    _vm._v(_vm._s(_vm.cta) + " "),
                    _c("span", {
                      staticClass: "arrow-right",
                      domProps: { innerHTML: _vm._s(_vm.svg("arrow-right")) }
                    })
                  ]
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        _vm.giftInterface.cta_kind && _vm.linkIsValid ? "a" : "div",
        {
          tag: "component",
          staticClass: "d-block position-relative",
          attrs: {
            href:
              _vm.giftInterface.cta_kind && _vm.linkIsValid
                ? _vm.giftInterface.cta_kind === "link"
                  ? "/" + _vm.giftInterface.cta_link
                  : _vm.route("nl.category", {
                      slug: _vm.giftInterface.cta_category.slug
                    })
                : null
          }
        },
        [
          _c("div", { staticClass: "mx-n24 mx-md-0" }, [
            _c("div", { staticClass: "gift-banner" }, [
              _vm.giftInterface.image
                ? _c("img", {
                    attrs: {
                      src: _vm.giftInterface.image.url,
                      alt: _vm.giftInterface.title
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _vm.giftInterface.title
                  ? _c("h3", { staticClass: "mb-8 text-white title" }, [
                      _vm._v(_vm._s(_vm.giftInterface.title))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.giftInterface.description
                  ? _c(
                      "p",
                      {
                        staticClass:
                          "small text-white font-weight-book description"
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.giftInterface.description) +
                            "\n                    "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.giftInterface.cta_kind != null &&
                _vm.giftInterface.cta_kind != "" &&
                _vm.linkIsValid
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-accent mt-16 align-self-start",
                        attrs: {
                          href:
                            _vm.giftInterface.cta_kind === "link"
                              ? "/" + _vm.giftInterface.cta_link
                              : _vm.route("nl.category", {
                                  slug: _vm.giftInterface.cta_category.slug
                                })
                        }
                      },
                      [
                        _vm._v(_vm._s(_vm.giftInterface.cta) + " "),
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.svg("arrow-right", "arrow-right")
                            )
                          }
                        })
                      ]
                    )
                  : _vm._e()
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }